import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
import DesignUnderLine from '../../components/ExcerciseTypes/Design/DesignUnderLine';
import UI from '../../components/ExcerciseTypes/Design/UserInterface';
import DrawColor from '../../components/ExcerciseTypes/DrawColor';

const json = {
  1: {
    unit: 'Unit 9',
    id: 'WB4-V2-U9-P63-E1',
    audio: '',
    video: '',
    component: D1,
    titleImage: '',
    exerciseKey: 'img/FriendsPlus/Page63/E1/Key/answerKey.png',
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page63/E1/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page63/E1/2.jpg' },
        { url: 'img/FriendsPlus/Page63/E1/3.jpg', input: true, answer: "rope" },
        { url: 'img/FriendsPlus/Page63/E1/4.jpg' },
        { url: 'img/FriendsPlus/Page63/E1/5.jpg', input: true, answer: "bone" },
        { url: 'img/FriendsPlus/Page63/E1/6.jpg' },
        { url: 'img/FriendsPlus/Page63/E1/7.jpg', input: true, answer: "stone" },
        { url: 'img/FriendsPlus/Page63/E1/8.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page63/E1/9.jpg' },
      ],


    ]
  },
  2: { // Exercise num
    unit: 'Unit 9',
    id: 'WB4-V2-U9-P63-E2',
    audio: '',
    video: '',
    component: D1,
    exerciseKey: 'img/FriendsPlus/Page63/E2/Key/answerKey.png',
    titleImage: '',
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page63/E2/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page63/E2/2.jpg' },
        { url: 'img/FriendsPlus/Page63/E2/3.jpg', input: true, answer: "stone" },
        { url: 'img/FriendsPlus/Page63/E2/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page63/E2/5.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page63/E2/6.jpg' },
        { url: 'img/FriendsPlus/Page63/E2/7.jpg', input: true, answer: "home" },
        { url: 'img/FriendsPlus/Page63/E2/8.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page63/E2/9.jpg' },
        { url: 'img/FriendsPlus/Page63/E2/10.jpg', input: true, answer: "nose" },
        { url: 'img/FriendsPlus/Page63/E2/11.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page63/E2/12.jpg' },
        { url: 'img/FriendsPlus/Page63/E2/13.jpg', input: true, answer: "bone" },
        { url: 'img/FriendsPlus/Page63/E2/14.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page63/E2/15.jpg' },
      ],


    ]
  },
  3: { // Exercise num
    unit: 'Unit 9',
    id: 'WB4-V2-U9-P63-E3',
    audio: '',
    video: '',
    component: DrawColor,
    exerciseKey: 'img/FriendsPlus/Page63/E3/Key/answerKey.png',
    titleQuestion: [{ num: '3', title: 'Read. Circle the words with o_e. Underline the words with o.', color: "#5B5A5D" }],
    question: {
      Write: {
        underlineStyle: {},
        inputStyle: {},
        answers: [],
        initialValue: [],
      },
      Circle: {
        listStyle: {
          normal: {},
          circle: { padding: 3, border: 'solid 2px', borderRadius: '50%', borderColor: 'gray' },
          underline: { borderBottom: '2px solid gray' },
          // square: { padding: 3, border: 'solid 2px', borderColor: '#4285F4' },
        },
        // limitSelect: 1,
        listWords: [
          "There is a pot in my home.",	//0
        ],
        answers: { '0-12': 'circle', '0-6': 'underline' },
        initialValue: {},
      },
      Layout: `
      <div style="line-height: 58px">
          <div>
          <img src="img/FriendsPlus/Page63/E3/1.jpg" />
          </div>
        <span style="margin-right:150px"> 
            A
            <u> fox </u>  has a
           <span style="border: 2px solid gray;padding:3px; border-radius: 50%;"> bone </span>  
        </span>
        <span><input id='0' type='Circle' /></span>
      </div>
      `,
    },
  },
  4: {
    unit: 'Unit 9',
    id: 'WB4-V2-U9-P63-E4',
    audio: '',
    video: '',
    component: D1,
    titleImage: '',
    checkDuplicated: true,
    exerciseKey: 'img/FriendsPlus/Page63/E4/Key/answerKey.png',
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page63/E4/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page63/E4/2.jpg' },
        { url: 'img/FriendsPlus/Page63/E4/3.jpg', input: true, answer: "bone/home" },
        { url: 'img/FriendsPlus/Page63/E4/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page63/E4/5.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page63/E4/6.jpg' },
        { url: 'img/FriendsPlus/Page63/E4/7.jpg', input: true, answer: "pot" },
        { url: 'img/FriendsPlus/Page63/E4/8.jpg' },
        { url: 'img/FriendsPlus/Page63/E4/9.jpg', input: true, answer: "bone/home" },
        { url: 'img/FriendsPlus/Page63/E4/10.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page63/E4/11.jpg' },
      ],

    ]
  },



}
export default json;